// @flow
import styled from 'styled-components';

import {
  px, mx, py
} from 'styled-components-spacing';

import breakpoint from 'styled-components-breakpoint';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@theme';

const { colors } = theme;

export const StyledForm = styled.form`
 display: flex;
  ${px(3)}
  background-color: white;
  align-items: center;
  box-shadow: 0 5px 3px 0px ${colors.transluscentDark};
  border-radius: 8px;
  position: relative;
  ${mx(1)}
  ${({ setted }) =>
    (setted
      ? `
    color: ${colors.darkBlue};
    background-color: ${colors.white};
  `
      : `
    color: ${colors.darkBlue};
    background-color: ${colors.white};
  `)}
  ${breakpoint('mobile', 'tablet')`
    width: 50%;
    ${py(1)}
    ${props => props.city && 'display: none;'}
  `}
  ${breakpoint('tablet', 'desktop')`
     height: 40px;
     width: 50%;
     ${props => props.city && 'display: none;'}
  `}
  
  ${breakpoint('desktop')`
    height: 50px;
    width: ${props => (props.city ? '10%' : '20%')};
  `}
`;

export const StyledSelectInput = styled.select`
  color: inherit;
  border: none;
  font-size: 20px;
  font-weight: 700;
  color: ${colors.translucentDarkBlue};
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ::-webkit-scrollbar {
    width: 20px;
  }
  ::-webkit-scrollbar-track {
    background: white;
  }
  ::-webkit-scrollbar-thumb {
    background: #a8a4a4;
    border-radius: 10px;
    border: 5px solid white;
  }
  ::-ms-expand {
    display: none;
  }
  align-self: center;
  option {
    color: ${colors.darkBlue};
    font-size: 18px;
    line-height: 29.26px;
  }
`;

export const StyledIconWrapper = styled.div`
  position: absolute;
  right: 0;
  ${px(3)}

  pointer-events: none;

  z-index: 10;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  color: ${colors.translucentDarkBlue};
  pointer-events: none;
`;
